import { configs } from '@constants/configs/configs';
import { PAGE_SIZE } from '@constants/common.constants';
import { MEMBER_HISTORICAL_DOCUMENTS_ACTION_TYPES } from '@constants/actionTypes/memberHistoricalDocumentsActionTypes';
import { createPaginatedFetchThunk } from '@common-actions/createPaginatedFetchThunk';
import {
    HISTORICAL_DOCUMENTS_DEFAULT_SORT_COLUMN,
    HISTORICAL_DOCUMENTS_DEFAULT_SORT_ORDER,
    HISTORICAL_DOCUMENTS_INITIAL_PAGE_NUMBER,
    HISTORICAL_DOCUMENTS_LIST_KEY,
    type IHistoricalDocumentsFetchRequest,
    type IHistoricalDocumentsListState,
    type IHistoricalDocumentsPageData,
} from '@modules/historical-documents/constants';

const buildBasePayload = (request: IHistoricalDocumentsFetchRequest) => ({
    hasLoaded: true,
    documents: [],
    totalCount: 0,
    pageNumber: request.pageNumber,
    pageSize: request.pageSize,
    totalPages: 0,
    sortColumn: request.sortColumn,
    sortOrder: request.sortOrder,
});

export const setMemberHistoricalDocuments = (payload: IHistoricalDocumentsListState) => ({
    type: MEMBER_HISTORICAL_DOCUMENTS_ACTION_TYPES.SET_MEMBER_HISTORICAL_DOCUMENTS,
    payload,
});

export const resetMemberHistoricalDocuments = () => ({
    type: MEMBER_HISTORICAL_DOCUMENTS_ACTION_TYPES.RESET_MEMBER_HISTORICAL_DOCUMENTS,
});

export const fetchMemberHistoricalDocuments = createPaginatedFetchThunk<
    IHistoricalDocumentsFetchRequest,
    IHistoricalDocumentsPageData,
    typeof HISTORICAL_DOCUMENTS_LIST_KEY,
    IHistoricalDocumentsListState
>({
    getEndpointUrl: () => configs.endpoints.MEMBER_HISTORICAL_DOCUMENTS,
    listKey: HISTORICAL_DOCUMENTS_LIST_KEY,
    setList: setMemberHistoricalDocuments,
    requestDefaults: {
        pageNumber: HISTORICAL_DOCUMENTS_INITIAL_PAGE_NUMBER,
        pageSize: PAGE_SIZE,
        sortColumn: HISTORICAL_DOCUMENTS_DEFAULT_SORT_COLUMN,
        sortOrder: HISTORICAL_DOCUMENTS_DEFAULT_SORT_ORDER,
    },
    buildEmptyPayload: (request) => ({ ...buildBasePayload(request), hasLoadError: false }),
    buildErrorPayload: (request) => ({ ...buildBasePayload(request), hasLoadError: true }),
    buildSuccessPayload: (pageData, request) => ({
        ...buildBasePayload(request),
        documents: pageData.userHistoricalDocuments,
        totalCount: pageData.totalElements,
        pageNumber: pageData.pageNumber,
        pageSize: pageData.pageSize,
        totalPages: pageData.totalPages,
        hasLoadError: false,
    }),
});
